import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import * as moment from 'moment';
import { EMPTY, from, of, Subject, switchMap, throwError } from 'rxjs';
import { catchError, filter, first, map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { Helpers } from '../../../../../helpers';
import { AppModulesType } from '../../../../../_shared/enums/appModulesType.enum';
import { PaperType } from '../../../../../_shared/enums/PaperType.enum';
import { SendInvoiceNotificationInfo } from '../../../../../_shared/model/accounting/invoice/sendInvoiceNotificationInfo.model';
import { Event } from '../../../../../_shared/model/event.model';
import { PopupPaper, PopupPaperData } from '../../../../../_shared/model/portfolio/popup-paper';
import { PortfolioPaper } from '../../../../../_shared/model/portfolio/portfolioPaper.model';
import { Case } from '../../../../../_shared/model/schedule/case.model';
import { PaperNamePipe } from '../../../../../_shared/pipes/paper-name.pipe';
import { ActiveModulesService } from '../../../../../_shared/services/activeModules.service';
import { HelperNavigateService } from '../../../../../_shared/services/helper-navigate.service';
import { HelperService } from '../../../../../_shared/services/helper.service';
import { MfToastService } from '../../../../../_shared/services/mfToast.service';
import { StorageService } from '../../../../../_shared/services/storage.service';
import { CancelCrppDocShareComponent } from '../../../../components/cancel-crpp-doc-share/cancel-crpp-doc-share.component';
import { MergeDocumentsComponent } from '../../../../components/merge-documents/merge-documents.component';
import { RenamePaperPopupComponent } from '../../../../components/rename-paper-popup/rename-paper-popup.component';
import { VisitHDExitPopupComponent } from '../../../../components/visitHD-exit-popup/visitHD-exit-popup.component';
import { FileSource } from '../../../telemedicine/enums/file-source.enum';
import { DocumentData } from '../../../telemedicine/model/document-data.model';
import { WebSocketChat } from '../../../telemedicine/model/web-socket-chat.model';
import { DocumentShareRequest } from '../../terms/visit/crpp/_model/crpp-document-request';
import { CrppDocumentsService } from '../../_services/crpp-documents.service';
import { ResultService } from '../../_services/result.service';
import { VisitService } from '../../_services/visit.service';
import { Customer } from './../../../../../_shared/model/customer.model';
import { ContractorSettings } from './../../../../../_shared/model/userGuiSettings/contractorSettings.model';
import { BaseState } from './../../../../../_shared/state/base/base.state';
import { DocumentViewerService } from './../../../../basic-components/document-viewer/document-viewer.service';
import { TelemedicineService } from './../../../telemedicine/telemedicine.service';
import { TermCommunicationsService } from './../../terms/visit/selected-term/terms-communications.service';
import { DocumentsService } from './../../_services/documents.service';
import { PfType } from './../_common/enum/pf-type.enum';

@Component({
    selector: 'portfolio-list',
    templateUrl: './portfolio-list.component.html',
    styleUrls: ['./portfolio-list.component.scss'],
})
export class PortfolioListComponent implements OnInit, OnDestroy {
    @Input()
    public customer?: Customer;

    @Input()
    public type: PfType = PfType.TERM;

    @Input()
    public prereservationId?: string;

    @Input()
    public case?: Case;

    @Input()
    set data(dataIn: PortfolioPaper[]) {
        if (!_.isNil(dataIn)) {
            this._data = dataIn;
            this.numberOfElements = this._data.length;
            this.generateNewItemsMenu();
        }
    }

    @Input()
    public termData: Event;

    @Input()
    public isEditable = true;

    @Input()
    public isHDView = false;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onSave = new EventEmitter();

    @Output() reload = new EventEmitter();

    @Input()
    public canConcludeG100 = false;

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public sourceVisit: any;

    public pfType = PfType;

    public contractorSettings: ContractorSettings = this.store.selectSnapshot(BaseState.GetContractorSettings);

    public isVisibleInput = false;
    public _data: PortfolioPaper[];
    public numberOfElements = 0;
    public itemsPerPage = 5;
    public currentPage = 1;
    public showHDWarning = false;
    public isHDActive = false;
    public canAddNewItems = false;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public createNewItems: any[] = [];
    private allNewItemsMenu = this.getAllNewMenuItems();
    private destroy$ = new Subject<void>();
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);

    constructor(
        private modalService: NgbModal,
        private paperNamePipe: PaperNamePipe,
        private rest: ResultService,
        private storage: StorageService,
        private helper: HelperService,
        private toast: MfToastService,
        private helperNavigate: HelperNavigateService,
        private isAm: ActiveModulesService,
        private wscs: TelemedicineService,
        private documentApi: DocumentsService,
        private store: Store,
        private dvs: DocumentViewerService,
        private visitRest: VisitService,
        private injector: Injector,
        private crppDocRest: CrppDocumentsService,
    ) {}

    ngOnInit() {
        this.isHDActive = this.isAm.isAM(AppModulesType.HELLO_DOCTOR);
        this.canAddNewItems = this.isEditable && (this.type == PfType.CUSTOMER || this.type == PfType.TERM);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getAllNewMenuItems(): any {
        const retVal = {};
        Object.keys(PaperType).forEach((paperType: PaperType) => {
            retVal[paperType] = {
                name: this.paperNamePipe.transform(paperType),
                paperType: paperType,
            };
        });
        return retVal;
    }

    private generateNewItemsMenu(): void {
        if (!this.isEditable) {
            return;
        }
        this.createNewItems = [];
        if (this.type === PfType.TERM) {
            if (this.termData?.visitId) {
                this.createNewItems.push(
                    this.allNewItemsMenu.IZVID,
                    this.allNewItemsMenu.FTH_POROCILO,
                    this.allNewItemsMenu.WHITE_REFERRAL,
                    this.allNewItemsMenu.CONFIRM_VISIT,
                );
                if (this.isHDActive) {
                    if (!this.find(PaperType.MFMEDICAL_IZVID)) {
                        this.createNewItems.push(this.allNewItemsMenu.MFMEDICAL_IZVID);
                    }
                    if (!this.find(PaperType.MEDIFIT_MEDICAL_REPORT)) {
                        this.createNewItems.push(this.allNewItemsMenu.MEDIFIT_MEDICAL_REPORT);
                    }
                    this.createNewItems.push(
                        this.allNewItemsMenu.MFMEDICAL_IZVID,
                        this.allNewItemsMenu.MEDIFIT_MEDICAL_REPORT,
                        this.allNewItemsMenu.HELLODOC_ORDERFORM_LAB,
                        this.allNewItemsMenu.HELLODOC_ORDERFORM_DIAG,
                    );
                }
                if (this.isAm.isAM(AppModulesType.OCCUPATIONAL_MEDICINE)) {
                    this.createNewItems.push(this.allNewItemsMenu.NAPREDNI_IZVID);
                    this.createNewItems.push(this.allNewItemsMenu.WORK_CERTIFICATE);
                    this.createNewItems.push(this.allNewItemsMenu.DRIVER_CERTIFICATE);
                    this.createNewItems.push(this.allNewItemsMenu.DRIVER_CERTIFICATE_SPECIAL);
                    this.createNewItems.push(this.allNewItemsMenu.WEAPON_CERTIFICATE);
                }
            } else {
                this.createNewItems.push(this.allNewItemsMenu.CONFIRM_RESERVATION);
            }
        } else if (this.type === PfType.CUSTOMER && this.contractorSettings?.portfolio?.visitNotMendatory) {
            this.createNewItems.push(this.allNewItemsMenu.SURVEY_CUSTOMER);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public openPreview(paper: PortfolioPaper | any, print: boolean = false): void {
        let dataCall$;
        const id = paper.paperId !== undefined ? paper.paperId : paper.id;
        switch (paper.paperType) {
            case PaperType.SURVEY_CUSTOMER:
                dataCall$ = this.rest.getPortfolioPaper(this.contractorId, id);
                break;
            case PaperType.FTH_POROCILO:
            case PaperType.IZVID:
            case PaperType.NAPREDNI_IZVID:
            case PaperType.CONFIRM_VISIT:
            case PaperType.HELLODOC_IZVID:
            case PaperType.MFMEDICAL_IZVID:
            case PaperType.MEDIFIT_MEDICAL_REPORT:
                dataCall$ = this.rest.getSurveyPaperPreview(paper.visitId, id);
                break;
            case PaperType.WHITE_REFERRAL:
            case PaperType.HELLODOC_REFERRAL:
            case PaperType.HELLODOC_ORDERFORM_LAB:
            case PaperType.HELLODOC_ORDERFORM_DIAG:
                dataCall$ = this.rest.printPortfolioPaper(this.storage.getSelectedContractor().id, id);
                break;
            case PaperType.CONFIRM_RESERVATION:
                dataCall$ = this.rest.getSurveyPaperPreviewReservation(paper.prereservationId, id);
                break;
            case PaperType.WORK_CERTIFICATE:
            case PaperType.WEAPON_CERTIFICATE:
            case PaperType.DRIVER_CERTIFICATE:
            case PaperType.DRIVER_CERTIFICATE_SPECIAL:
                dataCall$ = this.rest.getPortfolioPaper(this.contractorId, id);
                break;
            default:
                dataCall$ = of([]);
                break;
        }

        dataCall$
            .pipe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                map((res: any) => {
                    if (res.type !== 0) {
                        return new Blob([res.body], { type: 'application/pdf' });
                    }
                }),
                catchError(err => {
                    this.toast.errorAndSend('Napaka pri predogledu listine.');
                    Helpers.setLoading(false);
                    return throwError(() => err);
                }),
            )
            .subscribe(res => {
                if (res) {
                    this.helper.openDocumentViewer(res, res.type, this.paperNamePipe.transform(paper?.paperType), print);
                }
            });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public redirect(data: any) {
        if (data?.visitId) {
            this.helperNavigate.navigateToVisit(data.visitId);
        } else {
            this.helperNavigate.navigateToReservaton(data?.prereservationId);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public stopSharingDocument(paper: any) {
        const id: number = paper.id !== undefined ? paper.id : paper.paperId;

        this.documentApi
            .unsharePaper(this.contractorId, this.customer?.id, id)
            .pipe(
                catchError(err => {
                    this.toast.error('Napaka pri preklicu deljenja dokumenta');
                    return throwError(() => err);
                }),
            )
            .subscribe(() => {
                this.toast.success('Preklic deljenja dokumenta uspešen');
                paper.shared = false;
            });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public attachToHDChat(paper: any) {
        let chatData = [];
        this.wscs
            .getChatData(this.prereservationId)
            .pipe(
                takeUntil(this.destroy$),
                tap((chat: WebSocketChat[]) => {
                    if (chatData && chat) {
                        chatData.push(...(chat || []));
                    } else {
                        chatData = chat;
                    }
                }),
            )
            .subscribe(() => {
                const documentData = [
                    new DocumentData().deserialize({
                        documentId: paper?.id || paper?.paperId,
                        description: null,
                        contentType: 'application/pdf',
                        fileName: paper.paperType,
                        isImportedPaper: true,
                    }),
                ];
                this.wscs.sendChatSocketOuterComponent(this.prereservationId, '', documentData, FileSource.PAPER);
            });
    }

    public sendPaper(paper: PortfolioPaper): void {
        const id: number = paper.id !== undefined ? paper.id : paper.paperId;

        if (this.isHDActive && !paper.signedPaper) {
            this.toast.error('Listine ni mogoče poslati. Manjka podpis.');
            return;
        }

        this.dvs
            .shareDocument({ email: this.customer?.email, phone: this.customer?.phone })
            .pipe(
                filter(receiver => receiver !== undefined),
                mergeMap((receiver: SendInvoiceNotificationInfo) => this.documentApi.sharePaper(this.contractorId, this.customer?.id, id, receiver)),
                catchError(err => {
                    if (this.helper.checkStructError(err, 'shareCustomerData')) {
                        this.toast.warning('Listina je že deljena.');
                    } else {
                        this.toast.error('Napaka pri deljenju listine.');
                    }
                    return throwError(() => err);
                }),
            )
            .subscribe(() => {
                paper.shared = true;
                this.toast.success('Listina uspešno deljena.');
            });
    }

    public sendPaperToCrpp(paper: PortfolioPaper): void {
        from(this.helper.displayAlert('Pošiljanje v CRPP', 'S potrditvijo boste poslali in delili listino v CRPP.'))
            .pipe(
                switchMap(result => {
                    if (result.value) {
                        const data = {
                            prereservationId: this.prereservationId,
                            paperId: paper.id,
                        } as DocumentShareRequest;

                        return this.crppDocRest.storeDocument(data).pipe(
                            catchError(err => {
                                this.toast.error('Napaka pri deljenju listine v CRPP.');
                                return throwError(() => err);
                            }),
                            tap(() => {
                                paper.crppShared = true;
                                this.toast.success('Listina uspešno deljena v CRPP.');
                            }),
                        );
                    }
                    return EMPTY;
                }),
            )
            .subscribe();
    }
    public stopSharingDocumentToCrpp(paper: PortfolioPaper): void {
        const modalPopup = this.modalService.open(CancelCrppDocShareComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
        });
        modalPopup.componentInstance.paper = paper;
        modalPopup.componentInstance.preReservationId = this.termData.prereservationId;
        from(modalPopup.result).pipe(first()).subscribe();
    }

    public find(type) {
        const find = this._data?.find(el => el.paperType == type);
        return find ? true : false;
    }

    public onClick(paperType: string, paper?: PortfolioPaper) {
        if (this.type == PfType.TERM) {
            this.popupPaper(paperType, paper);
        } else if (this.type === PfType.CUSTOMER) {
            if (paperType == PaperType.SURVEY_CUSTOMER) {
                this.popupPaper(paperType, paper);
            } else {
                this.openPreview(paper);
            }
        }
    }

    public popupPaper(type: string, paper?: PortfolioPaper): void {
        if (type == PaperType.HELLODOC_REFERRAL || (this.isHDActive && type === PaperType.WHITE_REFERRAL && !this.find('HELLODOC_IZVID'))) {
            this.showHDWarning = true;
            return;
        }
        if (type == PaperType.HELLODOC_IZVID && this.find('HELLODOC_IZVID') && !paper) {
            return;
        }

        const paperPopupData = {
            prereservationId: this.prereservationId,
            termData: this.termData,
            sourceVisit: this.sourceVisit,
            case: this.case,
            customer: this.customer,
            pfType: this.type,
        } as PopupPaperData;

        new PopupPaper(this.modalService, this.paperNamePipe)
            .show(PaperType[type], paperPopupData, paper)
            .pipe(first())
            .subscribe(close => {
                this.showHDWarning = false;
                const isNew: boolean = _.isNil(paper);
                if (isNew || close || this.case) {
                    this.onSave.emit();
                }
            });
    }

    public concludeVisit(): void {
        const modalPopup = this.modalService.open(VisitHDExitPopupComponent, {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
        });
        modalPopup.componentInstance.term = this.termData;
        modalPopup.componentInstance.canConcludeG100 = this.canConcludeG100;
        from(modalPopup.result)
            .pipe(first())
            .subscribe(popupData => {
                if (popupData.success) {
                    //TODO update reservationTo
                    this.visitRest.NotifyVisitIsConcluded.next(true);
                    this.termData.isConcluded = true;
                    this.termData.visitEndDate = moment();
                    this.storage.setSelectedTerm(this.termData);
                    this.storage.setSelectedTerms(this.termData, this.termData.prereservationId);
                    this.toast.success('Obravnava zaključena.');
                }
            });
    }

    public onMergeWithDocument(paper: PortfolioPaper): void {
        const modalPopup = this.modalService.open(MergeDocumentsComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
        });
        modalPopup.componentInstance.paper = paper;
        modalPopup.componentInstance.preReservationId = this.termData.prereservationId;
        modalPopup.componentInstance.visitId = this.termData.visitId;
        modalPopup.componentInstance.termCommunicationsService = this.injector.get(TermCommunicationsService);
        from(modalPopup.result).pipe(first()).subscribe();
    }

    public renamePortfolioPaper(data: PortfolioPaper): void {
        const modalPopup = this.modalService.open(RenamePaperPopupComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
        });
        modalPopup.componentInstance.paper = data;
        modalPopup.componentInstance.contractorId = this.contractorId;

        from(modalPopup.result)
            .pipe(first())
            .subscribe(() => {
                this.reload.emit();
            });
    }
}
